import React from 'react';

import styles from './index.module.scss';

interface LegalLineProps {
  color?: 'white' | 'black';
  type?: 'simple' | 'full';
}

const LegalLine: React.FC<LegalLineProps> = ({ color = 'black', type = 'full' }) => {
  const legalLineClass = color === 'white' ? styles.white : styles.black;
  return (
    <div className={`${styles.LegalLine} ${legalLineClass}`}>
      <p>
        { type == 'full' && (<><a href="https://www.mcdonalds.it/friends-quiz--regolamento?openOutsideMcd=true" target="_blank" rel="noopener noreferrer">Regolamento</a> | <a href="https://www.mcdonalds.it/friends-quiz--privacy-policy?openOutsideMcd=true" target="_blank" rel="noopener noreferrer">Informativa Privacy</a><br /></>)}
        ©2026 McDonald's. TM&amp;© WBEI
      </p>
    </div>
  );
};

export default LegalLine; 